const PENDING_NAVIGATION_KEY = "pending-navigation";
const LEGACY_PENDING_NAVIGATION_KEY = "previous-path";

export const AUTH_ENTRY_PATHS = ["/", "/sign-in", "/re-login"];

export const isAuthEntryPath = (pathname = "") => (
  AUTH_ENTRY_PATHS.includes(String(pathname || "").toLowerCase())
);

export const getCurrentRelativeUrl = (location = window.location) => (
  `${location?.pathname || "/"}${location?.search || ""}${location?.hash || ""}`
);

export const isValidPendingNavigation = (target) => {
  if (typeof target !== "string" || !target.startsWith("/") || target.startsWith("//")) return false;

  try {
    const parsedTarget = new URL(target, "https://pending-navigation.local");
    return parsedTarget.origin === "https://pending-navigation.local"
      && !isAuthEntryPath(parsedTarget.pathname);
  } catch {
    return false;
  }
};

export const storePendingNavigation = (target = getCurrentRelativeUrl()) => {
  if (!isValidPendingNavigation(target)) return null;
  window.sessionStorage.setItem(PENDING_NAVIGATION_KEY, target);
  return target;
};

export const getPendingNavigation = () => {
  const perTabTarget = window.sessionStorage.getItem(PENDING_NAVIGATION_KEY);
  if (isValidPendingNavigation(perTabTarget)) return perTabTarget;

  const legacyTarget = window.localStorage.getItem(LEGACY_PENDING_NAVIGATION_KEY);
  return isValidPendingNavigation(legacyTarget) ? legacyTarget : null;
};

export const clearPendingNavigation = () => {
  window.sessionStorage.removeItem(PENDING_NAVIGATION_KEY);
  window.localStorage.removeItem(LEGACY_PENDING_NAVIGATION_KEY);
};

export const consumePendingNavigation = () => {
  const target = getPendingNavigation();
  clearPendingNavigation();
  return target;
};
